import { render, staticRenderFns } from "./SectionAd.vue?vue&type=template&id=1503e716&scoped=true"
import script from "./SectionAd.vue?vue&type=script&lang=js"
export * from "./SectionAd.vue?vue&type=script&lang=js"
import style0 from "./SectionAd.vue?vue&type=style&index=0&id=1503e716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1503e716",
  null
  
)

export default component.exports